module.exports = __webpack_public_path__ + "static/media/HairBack_2.184e9f54.jpg";